"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwError = throwError;
exports.peekError = peekError;
/** Allows an Error to be thrown from a ternary, null-coalescing or object initialiser, e.g.
 *
 * const config = {
 *    prop1: 5,
 *    prop2: process.env.SOMETHING ?? throwError('Environment variable SOMETHING was not defined'),
 *    prop3: process.env.SOMETHING_ELSE ?? 'SensibleDefault'
 * };
 *
 */
function throwError(message, options) {
    throw new Error(message, options);
}
/** Changes the type of an unknown object to one that can be traversed easily using simple ?. operators and .toString.
 * This does not actually wrap the object instance, instead it just does a type cast to IPeekErrorWrapperObject.
 *
 * This allows us to easily traverse error object without have to do lots of casting and assertions. It also forces us
 * to use the ?. (optional-chaining operator), which would cause runtime-errors if we used 'any'.
 *
 * e.g. we can do
 *
 * try {
 * }
 * catch (e) {
 *   peekError(e)?.cause?.information?.type?.code.toString() === '123';
 *   peekError(e)?.cause?.message.toString() === 'Something went wrong';
 * }
 */
function peekError(error) {
    return error;
}
//# sourceMappingURL=errors.js.map